/* ============================================================
   La La Lure — Custom Theme JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── Quick Add to Cart ──────────────────────────────────── */
  // Delegates click events on .lll-product-card__quick-add buttons
  // Uses Shopify's Ajax Cart API to add without page reload
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.lll-product-card__quick-add');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        // Refresh cart count bubble if Dawn's cart drawer is active
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Error — try again';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  });

  /* ── Newsletter Form ─────────────────────────────────────── */
  // Shopify handles newsletter forms natively via action="/contact#contact_form"
  // This just adds a client-side success message for better UX
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.lll-newsletter__form');
    if (!form) return;

    // Let Shopify handle the actual submission; show interim feedback
    const btn = form.querySelector('.lll-newsletter__btn');
    if (btn) {
      btn.textContent = 'Subscribing…';
      btn.disabled = true;
    }
  });

  /* ── Announcement Bar Rotator (optional) ────────────────── */
  // If multiple announcements are stored as data-items JSON attribute,
  // rotate through them every 4 seconds
  const bar = document.querySelector('.lll-announcement[data-items]');
  if (bar) {
    let items, idx = 0;
    try { items = JSON.parse(bar.dataset.items); } catch (_) { items = null; }

    if (items && items.length > 1) {
      const textEl = bar.querySelector('.lll-announcement__text');
      setInterval(function () {
        idx = (idx + 1) % items.length;
        if (textEl) {
          textEl.style.opacity = '0';
          setTimeout(function () {
            textEl.textContent = items[idx];
            textEl.style.opacity = '1';
          }, 300);
        }
      }, 4000);
    }
  }

  /* ── Photo Lightbox ─────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var photo = e.target.closest('.lll-testimonial-photo');
    if (photo) {
      var lightbox = document.getElementById('lll-lightbox');
      if (!lightbox) return;
      lightbox.querySelector('.lll-lightbox__img').src = photo.dataset.full || photo.src;
      lightbox.querySelector('.lll-lightbox__img').alt = photo.alt;
      lightbox.classList.add('lll-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      return;
    }
    if (e.target.closest('.lll-lightbox__backdrop') || e.target.closest('.lll-lightbox__close')) {
      var lb = document.getElementById('lll-lightbox');
      if (!lb) return;
      lb.classList.remove('lll-lightbox--open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var lb = document.getElementById('lll-lightbox');
      if (lb && lb.classList.contains('lll-lightbox--open')) {
        lb.classList.remove('lll-lightbox--open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  /* ── Scroll-triggered fade-up ────────────────────────────── */
  // Adds 'lll-fade-up--visible' once elements enter the viewport.
  // CSS handles the actual animation; this just applies the class.
  if ('IntersectionObserver' in window) {
    const targets = document.querySelectorAll(
      '.lll-product-card, .lll-bundle-card, .lll-ingredient-card, .lll-testimonial-card'
    );

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lll-fade-up--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }
})();
